// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groups-selector[data-v-4db4e0af]{background:#fafafa}.groups-selector__heading[data-v-4db4e0af]{max-width:733px;margin:0 auto;text-align:center}.groups-selector__nogroups[data-v-4db4e0af]{width:70%;margin:10px auto 40px;border:2px solid #ef3b39;border-radius:4px}.groups-selector__list[data-v-4db4e0af]{max-height:272px;margin:30px auto}", ""]);
// Exports
module.exports = exports;
